import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { FIELD_OPS_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { FeedbackDetailPage } from '@/features/feedback/pages/FeedbackDetailPage';
import { parsePositiveIdParams } from '@/utils/routeParams';

export const Route = createFileRoute('/_auth/feedback/list/$feedbackId')({
  beforeLoad: () => requirePermission(FIELD_OPS_PERMISSIONS.FEEDBACK_VIEW),
  parseParams: (rawParams) => {
    const params = parsePositiveIdParams(rawParams);
    if (params === null) throw notFound();
    return params;
  },
  component: function FeedbackDetailRoute() {
    const { feedbackId } = Route.useParams();
    return (
      <ErrorBoundary moduleName="Feedback Details">
        <Suspense fallback={<PageLoader />}>
          <FeedbackDetailPage feedbackId={feedbackId} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
